import { render } from "./WeekSliderBtnRight.vue?vue&type=template&id=5f41cf5c"
import script from "./WeekSliderBtnRight.vue?vue&type=script&lang=js"
export * from "./WeekSliderBtnRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__